import api from '../infra/api'
import apiCallHandler from './apiCallHandler'

export const getEmittingBanks = () => apiCallHandler(() => api.get('/resales-service/emitting-bank'))
